import React from 'react';
import { GuestButtons } from '@components';
import usePageTitle from '@hooks/usePageTitle';

const CaptivePortalGuest = () => {
  usePageTitle('Guest Account');
  return (
    <div className="flex justify-center py-3">
      <div className="w-full space-y-2 md:w-4/5 md:max-w-lg">
        <div className="mb-2 text-center">
          <h2 style={{ fontSize: '125%' }} className="pb-5">
            Guest access is limited duration and limited bandwidth.
          </h2>
        </div>
        If you are a Resident or Staff user, please go back and create an account or sign&nbsp;in.
        <GuestButtons captivePortal />
      </div>
    </div>
  );
};

export default CaptivePortalGuest;
